/**
 * @generated SignedSource<<459a78eee643b2c680f761308cad1dff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type moveProductsToCategoryDialogAssignMutation$variables = {
  categoryID: string;
  productID: string;
};
export type moveProductsToCategoryDialogAssignMutation$data = {
  readonly assignProductToCategory: {
    readonly id: string;
  };
};
export type moveProductsToCategoryDialogAssignMutation = {
  response: moveProductsToCategoryDialogAssignMutation$data;
  variables: moveProductsToCategoryDialogAssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryID",
        "variableName": "categoryID"
      },
      {
        "kind": "Variable",
        "name": "productID",
        "variableName": "productID"
      }
    ],
    "concreteType": "ProductCategory",
    "kind": "LinkedField",
    "name": "assignProductToCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveProductsToCategoryDialogAssignMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "moveProductsToCategoryDialogAssignMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "52c992f69a70f7e2f48bbbe7ee729113",
    "id": null,
    "metadata": {},
    "name": "moveProductsToCategoryDialogAssignMutation",
    "operationKind": "mutation",
    "text": "mutation moveProductsToCategoryDialogAssignMutation(\n  $categoryID: String!\n  $productID: String!\n) {\n  assignProductToCategory(categoryID: $categoryID, productID: $productID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "713f8eda3afe1dfc63c72a6839d8efa3";

export default node;
